import {React, useContext} from 'external/react'
import {makeStyles, Paper, Box} from 'external/material'
import {groupAssessmentSummary} from 'components/standards-selector/domain/assessment-summary.cjs'
import {TeacherContext} from 'teacher/context'

import SubjectAndGradeHeader from './components/subject-and-grade-header'
import Standard from './components/standard'

const useStyles = makeStyles(standardsStyles)

export default function AssessmentStandards (props) {

  const classes = useStyles()
  const context = useContext(TeacherContext)
  const {Wrapper = DefaultWrapper, withReferences = true} = props
  const {standardsContext, translate} = context
  const {assessmentStandards} = standardsContext
  const editionGroups = groupAssessmentSummary(assessmentStandards.items)

  return (
      <Wrapper>
        <Box className={classes.root}>
          {editionGroups.map(edition => (
            <Box key={edition.id} className={classes.editionGroup}>
              <Box className={classes.editionHeading}>{translate('standards')} · {edition.year}</Box>
              {edition.sections.map(section => (
                <Box key={`${edition.id}:${section.subject}:${section.grade}`} className={classes.subjectGroup}>
                  <SubjectAndGradeHeader standard={section.items[0]} />
                  {section.items.map(standard => (
                    <Standard key={`${edition.id}:${standard.id}`} standard={standard} withReferences={withReferences} />
                  ))}
                </Box>
              ))}
            </Box>
          ))}

          {assessmentStandards.items.length < 1 && (
            <Box className={classes.noStandards}>
              {assessmentStandards.loaded && translate('no-standards-specified')}
            </Box>
          )}
        </Box>
    </Wrapper>
  )
}

function DefaultWrapper (props) {
  const classes = useStyles()
  return (
    <Paper className={classes.defaultwrapper}>
      {props.children}
    </Paper>
  )
}

function standardsStyles () {
  return {
    defaultwrapper: {
      display: 'flex',
      flexGrow: 1,
      overflowY: 'hidden',
      padding: '15px 0 15px 15px'
    },
    root: {
      flexGrow: 1,
      padding: 15,
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto'
    },
    editionGroup: {
      marginBottom: 48,
      '&:last-child': {marginBottom: 0}
    },
    editionHeading: {
      fontSize: '19pt',
      fontWeight: 700,
      color: '#294e73',
      backgroundColor: '#eaf2fa',
      borderLeft: '5px solid #477eaf',
      padding: '14px 18px',
      marginBottom: 28
    },
    subjectGroup: {
      marginBottom: 32,
      '&:last-child': {marginBottom: 0}
    },
    noStandards: {
      display: 'flex',
      flexGrow: 1,
      padding: 30,
      justifyContent: 'center',
      color: '#3f5250',
      fontSize: '12pt',
      minWidth: '400px',
      minHeigth: '350px',
    }
  }
}
